// Module
var code = `<div class="content-block"> <app-change-password-widget [Type]="'ChangePasswordUser'" ID="0" (saveDataEvent)="SavePassword(\$event)"> </app-change-password-widget> </div> `;
// Exports
export default code;